module.exports = __webpack_public_path__ + "img/aboutRobotArm.40b3f016.webp";